import { Dayjs } from 'dayjs';
import React from 'react';
import { FormattedDate, FormattedTime } from 'react-intl';
import { Props } from 'react-intl/dist/components/relative';
import { Time } from './Time';

interface DataTempoProps {
  data: Dayjs
}

export const DataTempo: React.FC<DataTempoProps & Props> = ({data}) => {
  const date = data.toDate()

  return <Time data={data}>
    <FormattedDate value={date} />, <FormattedTime value={date} />
  </Time>;
}
